import { getHeight, getWidth } from "./chartUtils";

import { WindowSize } from "Utils/screenSizeUtils";
import { PlotParams } from "react-plotly.js";
import { ChartSize } from "./chartInterface";

export const DEFAULT_CHART_WIDTH = 492;
export const DEFAULT_CHART_HEIGHT = 400;
export const DEFAULT_CHART_FONT = "Open Sans";

export const getPlotConfig = (): PlotParams["config"] => ({
  responsive: true,
  staticPlot: false,
  displayModeBar: false,
  scrollZoom: false,
});

export const getChartSize = (
  windowSize: WindowSize,
  customHeight?: number,
  customWidth?: number,
): ChartSize => {
  return {
    height: getHeight(DEFAULT_CHART_HEIGHT, customHeight),
    width: getWidth(windowSize, DEFAULT_CHART_WIDTH, customWidth),
  };
};
